import { MapPin, Printer, Mail } from "lucide-react";
import { useLang } from "@/i18n";
import { OFFICIAL } from "@/data/media";
import { PageHero } from "@/components/PageHero";
import { ContactForm } from "@/components/ContactForm";
import { FadeUp } from "@/components/motion";

export default function Contact() {
  const { t } = useLang();
  const c = t.contact;
  const rows = [
    [MapPin, c.addressLabel, <>MADE ONLUS<br />{OFFICIAL.address}</>, null],
    [Printer, c.faxLabel, OFFICIAL.fax, `fax:${OFFICIAL.faxHref}`],
    [Mail, c.emailLabel, OFFICIAL.email, `mailto:${OFFICIAL.email}`],
  ];
  return (
    <>
      <PageHero eyebrow={c.eyebrow} lines={c.titleLines} intro={c.intro} />
      <section className="pb-24 sm:pb-32" data-testid="contact-section">
        <div className="wrap grid gap-8 lg:grid-cols-12">
          <FadeUp className="lg:col-span-4 bg-[var(--green-deep)] text-white p-8 sm:p-10 rounded-[2.5rem_2.5rem_2.5rem_0.5rem] h-fit" data-testid="contact-details">
            <h2 className="text-3xl">{c.detailsTitle}</h2>
            <ul className="mt-8 space-y-7">
              {rows.map(([Icon, label, value, href]) => (
                <li key={label} className="flex gap-4">
                  <span className="h-10 w-10 shrink-0 grid place-items-center rounded-full bg-white/15"><Icon size={18} /></span>
                  <div className="min-w-0">
                    <p className="text-xs uppercase tracking-[0.18em] text-[var(--yellow)]">{label}</p>
                    {href ? <a href={href} className="mt-1 block link-u break-all">{value}</a> : <p className="mt-1">{value}</p>}
                  </div>
                </li>
              ))}
            </ul>
            <p className="mt-8 pt-6 border-t border-white/20 text-sm text-white/80">{t.donate.cfLabel}: {OFFICIAL.cf}</p>
          </FadeUp>
          <FadeUp delay={0.1} className="lg:col-span-8 bg-white p-6 sm:p-10 rounded-[2.5rem] shadow-[0_0_0_1px_var(--line)]">
            <h2 className="text-3xl mb-8">{c.form.title}</h2>
            <ContactForm />
          </FadeUp>
        </div>
      </section>
    </>
  );
}
